import { DropAnimation } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';

interface DropAnimationOptions {
  duration?: number;
  easing?: string;
}

export const createDropAnimation = (
  translateX: number,
  translateY: number,
  options: DropAnimationOptions = {}
): DropAnimation => {
  const { duration = 200, easing = 'ease' } = options;

  return {
    duration,
    easing,
    keyframes: ({ transform }) => [
      { transform: CSS.Transform.toString(transform.initial ?? transform) },
      {
        transform: `translate3d(${translateX}px, ${translateY}px, 0)`,
      },
    ],
  };
};

interface Rect {
  left: number;
  top: number;
  width: number;
  height: number;
}

interface TransformOptions {
  offsetX?: number;
  offsetY?: number;
}

export const calculateDropTransform = (
  sourceRect: Rect,
  targetRect: Rect,
  options: TransformOptions = {}
): { translateX: number; translateY: number } | undefined => {
  const { offsetX = 0, offsetY = 0 } = options;

  const translateX = targetRect.left - sourceRect.left + offsetX;
  const translateY = targetRect.top - sourceRect.top + offsetY;

  return { translateX, translateY };
};

export const getRectCenter = (rect: Rect): { x: number; y: number } => ({
  x: rect.left + rect.width / 2,
  y: rect.top + rect.height / 2,
});
